import PASentry from "util/pa-sentry";
import isSafariBrowser from "./isSafari";

export default function canUseWebpImage() {
  try {
    if (!isSafariBrowser()) {
      return true;
    }
    const { userAgent } = navigator;
    const safariRegex = /Version\/(\d+\.\d+)/; // Regular expression to match the Safari version number

    const match = userAgent.match(safariRegex);
    if (match) {
      return parseFloat(match[1]) >= 14; // Convert the version string to a floating-point number
    }
  } catch (err) {
    PASentry.logException(err);
  }
  return true; // If Safari version is not found, return null
}
